import { InjectionToken } from '@angular/core';

declare global {
    interface Window {
        crl8?: Curalate.ICrl8;
    }
}

export namespace Curalate {
    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_MODULE_CURALATE_OPTIONS');

    export interface IModuleOptions {
        sitename?: string;
    }

    export interface ICrl8 {
        createExperience(containerSelector: string): Promise<any>;
        destroyExperience(containerSelector: string): Promise<undefined>;
        getExperience(containerSelector: string): Promise<ICrl8Experience>;
        getAllExperiences(): Promise<ICrl8Experience[]>;
        updateExperience(containerSelector: string): Promise<any>;
        debug?: boolean;
        ready: any;
        pixel: any;
    }

    export interface ICrl8Experience {
        isMounted: boolean;
        rootEl: HTMLElement;
        options: ICrl8ExperienceOptions;
    }

    export interface ICrl8ExperienceOptions {
        containerId: string;
        experienceId: string;
        experienceName: string;
        experienceType: string;
    }
}
